export enum TabTypes {
  Overview,
  Template,
  Activity
}
